import { createRouter, createWebHistory } from 'vue-router'
import LoginView from '@/views/Auth/LoginView.vue'
import HomeViewVue from '@/views/HomeView.vue'
import CollectView from '@/views/Collection/CollectView.vue'
import DeliverView from '@/views/Deliver/DeliverView.vue'
import SelectTruckView from '@/views/Truck/SelectTruckView.vue'

const routes = [
  {
    path: '/',
    name: 'login',
    component: LoginView
  },
  {
    path: '/home',
    name: 'userHome',
    component: HomeViewVue,
    meta: { requiresAuth: true }
  },
  {
    path: '/collect',
    name: 'collectHome',
    component: CollectView,
    meta: { requiresAuth: true }
  },
  {
    path: '/deliver',
    name: 'deliverHome',
    component: DeliverView,
    meta: { requiresAuth: true }
  },
  {
    path: '/select-truck',
    name: 'selectTruck',
    component: SelectTruckView,
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  let user = null;
  try {
    user = JSON.parse(sessionStorage.getItem("user"));
  } catch (e) {
    user = null;
  }
  const nfToken = sessionStorage.getItem("nfToken");

  // A session is only valid if it carries a driver JWT. A user without nfToken
  // is a stale session from before the JWT cutover (or an expired one): clear it
  // so the driver re-logins and obtains a token, otherwise API calls 401 once
  // auth enforcement is on.
  if (user && user.driverId && !nfToken) {
    sessionStorage.clear();
  }
  const isLoggedIn = !!(user && user.driverId && nfToken);

  if (to.matched.some(record => record.meta.requiresAuth) && !isLoggedIn) {
    next({ name: 'login' });
  } else if (to.name === 'login' && isLoggedIn) {
    next({ name: 'userHome' });
  } else {
    next();
  }
});

export default router;
